module.exports = __webpack_public_path__ + "static/img/SAM-CUMMING.5bca2f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-CUMMING.jpg
// module id = exyz
// module chunks = 0